import clsx from 'clsx';
import Link from 'next/link';
import { useContext } from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import { KaimonoWebRoutes } from 'src/config/routes';
import { useCart } from 'src/hooks/useCart';
import { I18nContext } from 'src/stores/I18n';
import styles from './index.module.scss';

type Props = {
  isSideMenuDisabled: boolean;
};
export const SideMenu: React.FC<Props> = ({ isSideMenuDisabled }) => {
  const localeResources = useContext(I18nContext);
  const { cart } = useCart();
  const cartLineCount = cart?.reduce((a, b) => a + b.quantity, 0) ?? 0;
  const goTop = () => {
    smoothscroll.polyfill();
    window.scroll({ top: 0, behavior: 'smooth' });
  };

  return isSideMenuDisabled ? null : (
    <aside className={styles.container}>
      <div className={styles.menus}>
        <Link href={KaimonoWebRoutes.cart}>
          <a className={styles.menu}>
            <span key="badge" className={styles.badge} suppressHydrationWarning>
              {cartLineCount || ''}
            </span>
            <span className={clsx(styles.icon, styles.cart)} />
            <p className={styles.title}>{localeResources.cart.title}</p>
          </a>
        </Link>
        <Link href={KaimonoWebRoutes.customerSupport}>
          <a className={styles.menu}>
            <span className={clsx(styles.icon, styles.customerSupport)} />
            <p className={styles.title}>{localeResources.customerSupport.title}</p>
          </a>
        </Link>
        <Link href={KaimonoWebRoutes.guide}>
          <a className={styles.menu}>
            <span className={clsx(styles.icon, styles.guide)} />
            <p className={styles.title}>{localeResources.guide.title}</p>
          </a>
        </Link>
        <Link href={KaimonoWebRoutes.walkthrough}>
          <a className={styles.menu}>
            <span className={clsx(styles.icon, styles.walkthrough)} />
            <p className={styles.title}>{localeResources.staticWalkthrough.title}</p>
          </a>
        </Link>
        <Link href={KaimonoWebRoutes.taxfreeGuide}>
          <a className={styles.menu}>
            <span className={clsx(styles.icon, styles.tax)} />
            <p className={styles.title}>{localeResources.taxFreeGuide.title}</p>
          </a>
        </Link>
        <div className={styles.goTop} onClick={goTop}>
          <span className={styles.goTopIcon} />
        </div>
      </div>
    </aside>
  );
};
